import { FC } from 'react'
import { Icon } from '@iconify/react'
import clsx from 'clsx'

import styles from './IntegratedAccountPill.module.css'

type Props = {
  isIntegrationValid: boolean
  companyLogo?: string
  isGoogleConnected?: boolean
}

export const IntegratedAccountPill: FC<Props> = ({
  companyLogo = 'https://assets.peppercontent.io/icons/social-media/google.svg',
  isIntegrationValid,
  isGoogleConnected = false
}) => {
  return (
    <div
      className={clsx(styles.pillWrapper, {
        [styles.active]: isIntegrationValid,
        [styles.integrationUnAvailable]: !isGoogleConnected
      })}
    >
      <img src={companyLogo} alt="account logo" className={styles.logo} />
      {isIntegrationValid ? (
        <Icon
          icon="lucide:check-circle-2"
          className={styles.tickIcon}
          width={16}
        />
      ) : (
        <Icon
          icon={isGoogleConnected ? 'lucide:alert-triangle' : 'lucide:x-circle'}
          className={clsx({
            [styles.warningIcon]: isGoogleConnected,
            [styles.error]: !isGoogleConnected
          })}
          width={16}
        />
      )}
    </div>
  )
}
